import React from 'react';
import { Switch, Route, Link } from 'react-router-dom';

import background from 'undraw/login.svg';

import Login from 'containers/Authentication/Login';
import Forgot from 'containers/Authentication/Forgot';
import Reset from 'containers/Authentication/Reset';
import Setup from 'containers/Authentication/Setup';

const Authentication = () => {
	// return (
	// 	<div className="min-h-full flex justify-center items-center bg-neutral-50 dark:bg-neutral-900">
	// 		<div className="m-4 flex flex-col p-4 w-full max-w-md">
	// 			<div className="text-5xl md:text-6xl font-extrabold text-center text-neutral-700 dark:text-neutral-200">
	// 				Pieslēgties
	// 			</div>

	// 			<div className="my-6 text-sm md:text-base text-center font-light tracking-wide text-neutral-400 dark:text-neutral-200">
	// 				Rīgas Tālmācības vidusskolas mācību vide.
	// 			</div>

	// 			<div className="p-6 rounded-xl bg-white dark:bg-neutral-800">
	// 				<Input
	// 					type="email"
	// 					name="email"
	// 					placeholder="E-pasts"
	// 				/>

	// 				<Input
	// 					type="password"
	// 					name="password"
	// 					placeholder="••••••••"
	// 					className="tracking-widest"
	// 					wrapClassName="mt-5"
	// 				/>

	// 				<div className="my-4 text-right">
	// 					<Link to="/forgot" className="text-sm md:text-base text-orange-300 hover:text-orange-400 focus:underline underline-offset-2 transition-all">
	// 						Aizmirsi paroli?
	// 					</Link>
	// 				</div>

	// 				<Submit
	// 					value="Pieslēgties"
	// 					className="w-full"
	// 				/>

	// 				{1 >= 2 && <div className="mt-4 py-3 px-4 text-sm md:text-base rounded-xl bg-rose-500 text-white anim">
	// 					Neizdevās pieslēgties! Pārliecinies, vai ievadītie dati ir korekti.
	// 				</div>}
	// 			</div>

	// 			<div className="mt-6 text-center text-sm md:text-base font-light tracking-wide text-neutral-400 dark:text-neutral-200">
	// 				Nav profila? Piesakies mācībām&nbsp;
	// 				<Link to="/" className="text-orange-300 hover:text-orange-400 focus:underline underline-offset-2 transition-all">šeit!</Link>
	// 			</div>
	// 		</div>
	// 	</div>
	// );
	return (
		<div className="authorization">
			<div className="authorization__background">
				<img src="https://pulekcijas.fra1.digitaloceanspaces.com/login.svg" alt="Sveiks!" />
			</div>

			<div className="authorization__container">
				<Switch>
					<Route path="/setup/:url">
						<Setup />
					</Route>

					<Route path="/reset/:url">
						<Reset />
					</Route>

					<Route path="/forgot">
						<Forgot />
					</Route>

					<Route path="/">
						<Login />
					</Route>
				</Switch>
			</div>
		</div>
	);
};

export default Authentication;
